/**
 * Product Ranking Display
 * 各商品カードの左上にランキング番号を表示する機能
 * カスタム設定に対応
 */

(function() {
  'use strict';

  function applyRanking(scope) {
    const root = scope || document;
    const productItems = root.querySelectorAll('.resource-list__item[data-product-ranking]');

    productItems.forEach((item) => {
      const ranking = item.getAttribute('data-product-ranking');
      if (!ranking) return;

      const cardGallery = item.querySelector('.card-gallery');
      if (!cardGallery) return;

      // 既存のランキングラベルを削除して再生成
      const existing = cardGallery.querySelector('.ranking-label');
      if (existing) existing.remove();

      const section = item.closest('[data-ranking-settings]');
      let settings = null;
      if (section) {
        try {
          const settingsJson = section.getAttribute('data-ranking-settings');
          if (settingsJson) {
            settings = JSON.parse(settingsJson);
          }
        } catch (e) {
          console.warn('Failed to parse ranking settings:', e);
        }
      }

      const rankingLabel = createRankingLabel(ranking, settings);
      cardGallery.insertBefore(rankingLabel, cardGallery.firstChild);
    });
  }

  function createRankingLabel(ranking, settings) {
    const label = document.createElement('div');
    const rankNum = parseInt(ranking, 10);

    label.className = 'ranking-label';
    label.setAttribute('aria-label', `ランキング ${ranking}位`);
    label.textContent = ranking;

    if (settings) {
      const rankKey = rankNum <= 3 ? `rank${rankNum}` : 'rank4plus';
      const rankSettings = settings[rankKey] || {};

      const paddingValue = settings.padding || 8;

      label.style.position = 'absolute';
      label.style.top = '8px';
      label.style.left = '8px';
      label.style.zIndex = '10';
      label.style.display = 'inline-flex';
      label.style.alignItems = 'center';
      label.style.justifyContent = 'center';
      label.style.fontSize = `${settings.fontSize || 14}px`;
      label.style.fontFamily = settings.fontFamily || 'var(--font-body--family)';
      label.style.fontWeight = settings.fontWeight || '600';
      label.style.borderRadius = `${settings.borderRadius || 4}px`;
      label.style.paddingTop = `${paddingValue}px`;
      label.style.paddingRight = `${paddingValue}px`;
      label.style.paddingBottom = `${paddingValue}px`;
      label.style.paddingLeft = `${paddingValue}px`;
      label.style.border = rankSettings.borderWidth !== undefined
        ? `${rankSettings.borderWidth}px solid ${rankSettings.borderColor || 'transparent'}`
        : 'none';
      label.style.color = rankSettings.textColor || 'var(--color-foreground)';
      label.style.backgroundColor = rankSettings.bgColor || '#f5f5f5';
      label.style.boxSizing = 'border-box';
      label.style.lineHeight = '1';
    } else {
      let rankClass = 'default';
      if (rankNum === 1) rankClass = '1';
      else if (rankNum === 2) rankClass = '2';
      else if (rankNum === 3) rankClass = '3';

      label.className = `ranking-label ranking-label--${rankClass}`;
    }

    return label;
  }

  // 初回実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyRanking());
  } else {
    applyRanking();
  }

  // カスタマイザーでセクションが再レンダリングされた場合に再適用
  document.addEventListener('shopify:section:load', (event) => {
    applyRanking(event.target);
  });

  // カスタマイザーで設定変更された場合にも再適用
  // (セクション全体の再レンダリングではなく、属性のみ変わるケースに対応)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-ranking-settings') {
        applyRanking(mutation.target);
      }
    }
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-ranking-settings'],
    subtree: true,
  });
})();
